import { VdTracking } from '@vend/vend.js'
import { IAttributes } from 'angular'

import { STATES } from '../../../../../lib/routes'
import { RegisterManager } from '../../../managers/register-manager'
import { $state } from '../../../ng-compat/imports'

/**
 * Controller Class for RegisterOpenReminder
 */
export class RegisterOpenReminderController {
  public description: string
  public heading: string

  constructor(
    private $attrs: IAttributes,
    private vdTracking: VdTracking,
    public registerManager: RegisterManager
  ) {
    'ngInject'

    const count = this.registerManager.activeRegisterDaysOpen()
    this.heading = `This register has been open ${
      count === 1 ? 'since yesterday' : `for ${count} days`
    }.`
    this.description =
      'Having sales from multiple days in one register closure could create problems when you reconcile your accounts.'
  }

  public $postLink() {
    this.$attrs.$addClass('register-open-reminder')
  }

  public dismissReminder() {
    const activeRegister = this.registerManager.getActiveRegister()

    this.registerManager.setOpenRegisterReminderSeen({
      registerId: activeRegister.id,
      registerOpenSequenceId: activeRegister.register_open_sequence_id!,
    })
    this.vdTracking.trackUserEvent({
      eventName: 'Register Open Reminder',
      metadata: {
        action: 'Start selling anyway',
        daysOpen: this.registerManager.activeRegisterDaysOpen(),
      },
    })
  }

  public viewRegisterClosure() {
    this.vdTracking.trackUserEvent({
      eventName: 'Register Open Reminder',
      metadata: {
        action: 'Close register first',
        daysOpen: this.registerManager.activeRegisterDaysOpen(),
      },
    })

    $state.go(STATES.CLOSE_REGISTER)
  }
}
